var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Ciudades","storeName":"Cities","parentStoreName":"Provinces","parentUrlKey":"province_id","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"labelBack":"Atrás","canSearch":"","sortable":"","breadcrumbs":[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/provinces'
      },
      {
        text: 'Ciudades',
        disabled: false,
        href: '#'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }